<div class="space-y-3">
  @if (isNotNil(readonlyReason())) {
    <div
      class="rounded-sm border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800">
      {{ readonlyReason() }}
    </div>
  }

  <div class="flex justify-end">
    <p-button
      (onClick)="handleAddClick()"
      [disabled]="isReadonly()"
      appPrimengButton
      [label]="addButtonLabel()"
      size="small" />
  </div>

  @if (items().length > 0) {
    <div class="space-y-3">
      @for (item of items(); track item.id ?? item.name; let index = $index) {
        <div class="rounded-lg border border-gray-200 bg-white p-4">
          <div class="grid gap-4 md:grid-cols-[5rem_minmax(0,1fr)_9rem_auto] md:items-center">
            <div class="size-20 shrink-0">
              @if (isNotNil(item.featuredFileUrl)) {
                <app-image-thumbnail size="full">
                  <img
                    [ngSrc]="item.featuredFileUrl"
                    [fill]="true"
                    [alt]="item.featuredFileAlt"
                    class="object-contain" />
                </app-image-thumbnail>
              } @else {
                <app-image-thumbnail-unsupported size="lg" />
              }
            </div>

            <div class="min-w-0">
              <div class="text-sm font-semibold break-words text-gray-900">
                {{ item.name }}
              </div>

              <div class="mt-1 text-sm break-words text-gray-500">
                @if (isNotNil(item.sourceName)) {
                  {{ item.sourceName }}
                } @else {
                  <app-no-data />
                }
              </div>
            </div>

            <app-form-control label="Ilość">
              <p-input-number
                (ngModelChange)="handleQuantityChange(index, $event)"
                [disabled]="isReadonly()"
                [min]="1"
                [ngModel]="item.quantity"
                [showButtons]="false"
                [useGrouping]="false"
                inputStyleClass="w-full" />
            </app-form-control>

            <div class="flex justify-end">
              <p-button
                (onClick)="handleRemoveClick(index)"
                [disabled]="isReadonly()"
                appPrimengButton
                label="Usuń"
                severity="danger"
                size="small" />
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div
      class="rounded-sm border border-dashed border-gray-300 px-4 py-5 text-sm text-gray-500 italic">
      {{ emptyMessage() }}
    </div>
  }
</div>

@if (modalVisible()) {
  <app-admin-order-shipment-item-select-modal
    [excludedIds]="excludedIds()"
    [type]="type()"
    [visible]="modalVisible()"
    (cancelEvent)="handleModalCancelEvent()"
    (submitEvent)="handleModalSubmitEvent($event)" />
}
